export default "__VITE_ASSET__CFQNYG$z__"